const FormError = ({ message }) => {
  if (!message) return null;

  return (
    <p
      style={{
        color: "red",
        fontSize: "14px",
        marginTop: "5px",
      }}
    >
      {message}
    </p>
  );
};

export default FormError;
